import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import TokenService from '@Services/token.service';
import { AuthState } from '@Typings/auth.types';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    accessToken: null,
    refreshToken: null,
    role: undefined,
  } as AuthState,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { accessToken, refreshToken, isLoggedIn, role },
      }: PayloadAction<AuthState>
    ) => {
      // updating the state
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.isLoggedIn = isLoggedIn;
      state.role = role;
      // storing tokens in localStorage
      TokenService.setAccessToken(accessToken ?? '');
      TokenService.setRefreshToken(refreshToken ?? '');

      if (role) {
        TokenService.setUserRole(role);
      }
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.role = undefined;
      TokenService.removeAllTokens();
      state.isLoggedIn = false;
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
